//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Portal.Simon',
                {
                    url: '/Simon',
                    component: 'simonComponent',
                    resolve: {},
                });
        }
    ]);

    app.component('simonComponent', {
        templateUrl: 'App.Portal/States/Simon/Simon.template.html',
        controller: 'SimonController',
        bindings: {
            user: "<",
            userGroup: "<",
            logo: "<",
            delegates: "<",
            onBehalfOfUser: "<",
        }
    });

    app.controller('SimonController', SimonController);

    SimonController.$inject = ['$window', 'ssoApi', 'permissionService','externalLoading'];

    function SimonController($window, ssoApi, permissionService, externalLoading) {
        var $ctrl = this;

        $ctrl.title = 'Simon';

        $ctrl.$onInit = function () {
            /*if (permissionService.hasOnePermission("Simon:View")) {
                //var w = window.open();
                var w = $window.open("", "theFrame");
                w.document.write(externalLoading.html);
                ssoApi.initiateSimonSso().then(function (data) {
                    console.log(data);
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }*/
        };
    }
})(window.angular, window.app);